export default function withdrawStatus(status) {
    let text;
    switch (status) {
        case 1: {
            text = "در انتظار";
            break;
        }
        case 2: {
            text = "انجام شد";
            break;
        }
        case 3: {
            text = "لغو شده";
            break;
        }
        default: {
            text = "نامعتبر";
            break;
        }
    }
    return text
}
